import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactDOM from 'react-dom';
import DOMPurify from 'dompurify';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { getFullImagePath, isEmptyObject, getMainImagePath, getBackgroundImageSrc } from 'common/utilities/utils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { NUTRITION_ALLERGEN_CONSTANTS } from 'organisms/NutritionAllergen/Constants/NutritionAllergenConstant';
import ModalComponent from 'molecules/Modal';
import ImageComponent from 'atoms/Image';
import { getCmsClient } from 'common/utilities/cmsClient';
import getNutritionAllergenDisclaimer from '@kfc-global/react-shared/redux/Actions/NutritionAllergenDisclaimerAction';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import NutritionContainer from 'organisms/NutritionAllergen/Presentation/NutritionContainer';
import AllergenContainer from 'organisms/NutritionAllergen/Presentation/AllergenContainer';
import get from 'lodash/get';
const NutitionAllergenComponent = props => {
  const { isMobile, summaryData, source } = props;
  const { nutritionalDetails, allergenDetails, customizable, pdpCardObject, calories, nutritionDetails, servesCount } =
    summaryData;
  const { dName } = pdpCardObject;
  const { showNutritionAllergenModal, handleCloseModal } = nutritionDetails;
  const { imageName, imageContainerSize, pdpbackgroundImageData } = summaryData;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getNutritionAllergenDisclaimer({
        object: getCmsClient(),
        contentFull: {
          content_type: 'supportContent',
          include: '5',
          'fields.title': 'NutritionAllergenDisclaimer',
        },
      }),
    );
  }, [dispatch]);
  let segmentednutritionAllergenDisclaimer = null;
  const allReducerData = useSelector(data => {
    return {
      nutritionAllergenDisclaimerContent: get(
        data,
        NUTRITION_ALLERGEN_CONSTANTS.NUTRITION_ALLERGEN_ACTION_RESPONSE,
        null,
      ),
    };
  });

  if (isEmptyObject(allReducerData?.nutritionAllergenDisclaimerContent)) {
    segmentednutritionAllergenDisclaimer =
      allReducerData?.nutritionAllergenDisclaimerContent?.nutritionAllergenDisclaimerResp?.items[0]?.fields.content[0]
        ?.fields?.richText?.content;
  }

  const [showPerServe, setShowPerServe] = useState(true);
  const [showPerGram, setShowPerGram] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const { tenantReducer } = useSelector(data => {
    return {
      tenantReducer: data.tenantReducer || {},
    };
  });
  const accordianHandler = e => {
    e.preventDefault();
    e.stopPropagation();
    setExpanded(!expanded);
  };

  const nutritionAllergenModalProps = {
    id: 'NutritionAllergenModal',
    role: 'dialog',
    modalTitleId: 'NutritionAllergen-Modal-id',
    show: showNutritionAllergenModal,
    classNames: 'Base-modal  NutritionAllergen-modal',
    showCloseBtn: true,
    showBackBtn: false,
    closeButtonHandler: handleCloseModal,
    modalTitle: translateWithI18Next(TRANSLATE_MAPPING_KEY.NUTRITION_ALLERGEN_INFORMATION),
    modalTitleRequired: true,
    closeDataTestId: 'close-modal',
    autoFocus: true,
  };
  function perServeHandler(event) {
    event.preventDefault();
    setShowPerServe(true);
    setShowPerGram(false);
  }
  function perGramHandler(event) {
    event.preventDefault();
    setShowPerGram(true);
    setShowPerServe(false);
  }

  return ReactDOM.createPortal(
    <ModalComponent {...nutritionAllergenModalProps}>
      <div className='nutrition-allergen-container-global'>
        <div
          className='nutrion-allergen-image-container'
          style={getBackgroundImageSrc(
            pdpbackgroundImageData,
            imageContainerSize.containerWidth,
            imageContainerSize.containerHeight,
          )}
        >
          <ImageComponent
            data-testid=''
            className='nutrition-allergen-card-image-global'
            defaultPath={getFullImagePath(null, tenantReducer, true)}
            srcFile={getMainImagePath(imageName, imageContainerSize.containerWidth, imageContainerSize.containerHeight)}
          />
        </div>
        <div className='nutrition-allergen-details-section'>
          <div className='product-details-header'>
            <div className='d-flex strips-icon'>
              <ImageComponent
                srcFile={isMobile ? IMAGE_PATH.StripsIconMobile : IMAGE_PATH.StripesIcon}
                className='stripes-img'
              />
            </div>
            <div className='product-name'>{dName}</div>
            <div className='kj-info-details'>
              {calories && (
                <span className='kj-info'>{` ${calories} ${translateWithI18Next(
                  TRANSLATE_MAPPING_KEY?.SERVES,
                )} ${servesCount}`}</span>
              )}
            </div>
          </div>
          <div className='nutrition-allergen-list-global'>
            <NutritionContainer
              nutritionalDetails={nutritionalDetails}
              onClickServehandler={perServeHandler}
              onClickGramHandler={perGramHandler}
              showPerGram={showPerGram}
              showPerServe={showPerServe}
            />
            <AllergenContainer
              allergenDetails={allergenDetails}
              customizable={customizable}
              handleCloseModal={handleCloseModal}
              source={source}
            />
            <div className={`disclaimer-section ${expanded ? 'disclaimer-section-open' : ''}`}>
              <div className='global-accordian-container' data-testid='global-accordian'>
                <div
                  className={`global-accordian-header-container ${expanded ? 'active' : ''}`}
                  onClick={accordianHandler}
                  data-testid='disclaimer-handle'
                >
                  <span className='global-accordian-header'>
                    {translateWithI18Next(TRANSLATE_MAPPING_KEY.DISCLAIMER)}
                  </span>
                </div>
                {expanded && (
                  <div className='global-accordian-content'>
                    <div className='disclaimer-content'>
                      {segmentednutritionAllergenDisclaimer?.map(item => {
                        return (
                          <ul
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(documentToHtmlString(item)),
                            }}
                            className='protected-accordian-answer'
                          />
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalComponent>,
    document.getElementById('modal-popups'),
  );
};
export default NutitionAllergenComponent;
